<div class="merchant-card-wrapper" *ngIf="!cashCreditPricing">
  <h2>Featured Merchant<span *ngIf="showAllMerchants">s</span></h2>
  <div class="all-merchants" *ngIf="showAllMerchants">
    <div *ngFor="let merchant of displayMerchantList" (click)="showHowItWorks(merchant)">
      <div class="new-card banner-wrapper" [class.disabled]="googlepayFlowEnabled"
        [style.background-image]="'url(' + s3Url + '/config-assets/banners/' + (merchant.genericBanner) + '.png)'">
      </div>
    </div>
    <div class="view-all-wrapper">
      <a (click)="showAllMerchantsModal()">View All</a>
    </div>
  </div>
  <div *ngIf="!showAllMerchants && !(states.customer.creditLimitActive && merchantConfig?.offlineGC)">
    <div class="new-card banner-wrapper" (click)="showHowItWorks(merchantBannerConfig)"
      *ngIf="merchantBannerConfig?.bannerList?.length > 1">
      <div class="banner" *ngFor="let banner of merchantBannerConfig.bannerList"
        [style.background-image]="'url(' + s3Url + '/config-assets/banners/' + (banner) + '.png)'"></div>
    </div>
    <div class="new-card banner-wrapper" (click)="showHowItWorks(merchantBannerConfig)"
      *ngIf="!merchantBannerConfig?.bannerList?.length && merchantBannerConfig?.genericBanner"
      [style.background-image]="'url(' + s3Url + '/config-assets/banners/' + (merchantBannerConfig?.genericBanner) + '.png)'">
    </div>
    <div class="new-card logo-card"
      *ngIf="merchantKey !== 'makemytrip' && !merchantBannerConfig?.bannerList?.length && !merchantBannerConfig?.genericBanner">
      <a [href]="merchantRedirectUrl ? merchantRedirectUrl : ('javascript:void(0);' | safe)">
        <div *ngIf="!customIcon && merchantName">
          <img [src]="s3Url + '/logo-icons/' + (merchantName | lowercase) + '-logo-icon.png'"
            (error)="showCustomIcon()" />
          <div *ngIf="states?.customer?.creditLimitActive">Shop now</div>
        </div>
        <button class="btn zest-btn outline nameMerchant" *ngIf="customIcon">SHOP ON
          {{merchantName | uppercase}}</button>
      </a>
    </div>
  </div>
</div>
<div class="new-card" *ngIf="!showAllMerchants && (states.customer.creditLimitActive && merchantConfig?.offlineGC)">
  <zest-offline-gc-gen-info [cl]="clState?.credit_limit?.available_amt" [states]="states">
  </zest-offline-gc-gen-info>
  <zest-gc-redeem-info [merchantKey]=merchantKey></zest-gc-redeem-info>
</div>
<div class="new-card primary merchant-card-wrapper" *ngIf="kycDone && cashCreditPricing && cashCreditMerchantName">
  <zest-cash-credit [pricing]="cashCreditPricing" [merchantName]="cashCreditMerchantName"
    [merchantId]="states.customer.customCLMerchantId"></zest-cash-credit>
</div>
<div class="new-card redemption-section" *ngIf="isETMoney">
  <zest-loans></zest-loans>
</div>
<div id="howItWorks" class="modal new-modal" [class.bottom-sheet]="!isDesktop" materialize="modal">
  <div class="modal-content">
    <div class="header">
      <h2 class="title text-center">
        Shop any product on {{merchantName}} and pay using ZestMoney EMI
      </h2>
      <div class="close-btn" (click)="toggleStepsModal('close')">
        <i class="material-icons">close</i>
      </div>
    </div>
    <div class="sub-title text-center">Get 0% Interest on selected EMI plans*</div>
    <div class="main-modal-content">
      <div class="steps">
        <div class="step">
          <span class="index">1</span>
          <img src="/assets/images/voucher/hiw-1.png" alt="" class="step-illus">
          <p class="step-desc">
            Enter the product name you wish to buy
          </p>
        </div>
        <div class="step">
          <span class="index">2</span>
          <img src="/assets/images/voucher/hiw-2.png" alt="" class="step-illus">
          <p class="step-desc">
            Confirm the voucher value
          </p>
        </div>
        <div class="step">
          <span class="index">3</span>
          <img src="/assets/images/voucher/hiw-3.png" alt="" class="step-illus">
          <p class="step-desc">
            Select your EMI plan
          </p>
        </div>
        <div class="step">
          <span class="index">4</span>
          <img src="/assets/images/voucher/hiw-4.png" alt="" class="step-illus">
          <p class="step-desc">
            Generate the voucher
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn waves-effect zest-btn get-voucher" (click)="getVoucher(merchantName)">
      GET {{merchantName | uppercase}} VOUCHER
    </button>
  </div>
</div>

<div id="all-merchants" class="modal new-modal" [class.bottom-sheet]="!isDesktop" materialize="modal">
  <div class="modal-content">
    <div class="header">
      <h2 class="title">Popular Brands</h2>
      <div class="close-btn" (click)="showAllMerchantsBottomSheet('close')">
        <i class="material-icons">close</i>
      </div>
    </div>
    <div class="main-modal-content">
      <div class="emi-merchants-container">
        <a class="emi-merchant" *ngFor="let merchant of allMerchantBannerConfig" [class.disabled]="googlepayFlowEnabled"
          (click)="showHowItWorks(merchant, true)">
          <div class="icon-wrapper">
            <div class="merchant-icon"
              [style.background-image]="'url(' + s3Url + '/config-assets/logo-icons/' + (merchant.merchantName | lowercase) + '-icon.png)'">
            </div>
          </div>
          <span class="merchant-text">{{merchant.displayName ? merchant.displayName : merchant.merchantName}}</span>
          <div class="offer-div" *ngIf="merchant.offer">OFFER</div>
        </a>
      </div>
    </div>
  </div>
</div>